/** Unit parties (investment) — menu_item_id 4 */
export const UNIT_PARTIES_INDEX = 1197;
export const UNIT_PARTIES_STORE = 1198;
export const UNIT_PARTIES_SHOW = UNIT_PARTIES_INDEX;
export const UNIT_PARTIES_UPDATE = 1200;
export const UNIT_PARTIES_DESTROY = 1201;

/** Unit investment */
export const UNIT_INVESTMENT_SUMMARY = 1202;
export const UNIT_INVESTMENT_OWNER_LEDGER = 1203;
export const UNIT_INVESTMENT_VALIDATE_SHARES = 1204;
export const UNIT_INVESTMENT_ALLOCATE_EXPENSE = 1205;
export const UNIT_INVESTMENT_OWNER_BALANCES = 1206;
export const UNIT_INVESTMENT_LIST_CYCLES = 1207;
export const UNIT_INVESTMENT_CREATE_MANUAL = 1208;
export const UNIT_INVESTMENT_FROM_SALE = 1209;
export const UNIT_INVESTMENT_FROM_OPEN_BALANCE = 1210;
export const UNIT_INVESTMENT_SHOW_CYCLE = 1211;
export const UNIT_INVESTMENT_RELEASE_EARNINGS = 1212;
export const UNIT_INVESTMENT_CANCEL_CYCLE = 1213;
export const UNIT_INVESTMENT_RELEASE_PARTY_BALANCE = 1214;

/**
 * The central key service's approval number for `unit_investment.deposit_party_balance`,
 * which `2026_09_15_000015_add_unit_party_deposit_permission.php` writes as the permission
 * row's id — the two must stay equal. Read, not derived from the release key above.
 */
export const UNIT_INVESTMENT_DEPOSIT_PARTY_BALANCE = 1601;
